import SceneObject from "./scene-object";
import HallEntrance from "./components/hall-entrance";

export default class SceneManager {

    static fromJSON(sdk, data) {
        const instance = new SceneManager(sdk);

        if (data != null) {
            for (const { component, parameters, position } of data) {
                instance.addObject(component, parameters)
                    .then(object => {
                        object.node.position.set(...position);
                    });
            }
        }

        return instance;
    }

    _objects = new Set();

    constructor(sdk) {
        this._sdk = sdk;
        this.sceneObject = (async () => (await this._sdk.Scene.createObjects(1))[0])();
        this.registered = registerComponents(this._sdk);
    }

    get objects() {
        return [...this._objects];
    }

    async addObject(componentName, parameters) {
        await this.registered;

        const object = new SceneObject(await this.sceneObject, componentName, parameters);
        this._objects.add(object);

        return object;
    }

}

const COMPONENT_LIST = [
    HallEntrance,
];

async function registerComponents(sdk) {
    const promises = [];

    for (const COMPONENT of COMPONENT_LIST) {
        promises.push(sdk.Scene.register(COMPONENT.COMPONENT_NAME, () => new COMPONENT()));
    }

    await Promise.all(promises);
}
